module.exports = __webpack_public_path__ + "img/bronzeShadow.d51c4761.webp";